import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

import { MobileNavProvider } from "../../store/context/MobileNavContext.js";
import { useResponsive } from "../../hooks/useResponsive.js";
import logo from "../../assets/logo.png";

import BackspaceNavigation from "../../services/utils/BackspaceNavigation.js";
import ScrollToTop from "../../services/utils/ScrollToTop.js";

import Header from "../header/Header.js";
import HeaderMobile from "../header/HeaderMobile.js";
import Sidebar from "../header/Sidebar.js";
import packageJson from "../../../package.json";
import { selectVar } from "../../store/conf/confSlice.js";

function Layout({ children }) {
  const { isMD } = useResponsive();
  const token = localStorage.getItem("authToken");
  const _BKG_LOGO = useSelector(selectVar("_BKG_LOGO", logo));

  // 🔒 Body-lock orizzontale su iOS: blocca pan-X fuori dalle row con data-xscroll
  useEffect(() => {
    let startX = 0, startY = 0;

    const isInsideXScroll = (el) => {
      while (el) {
        if (el.dataset && el.dataset.xscroll !== undefined) return true;
        el = el.parentElement;
      }
      return false;
    };

    const onTouchStart = (e) => {
      const t = e.touches[0];
      startX = t.clientX;
      startY = t.clientY;
    };

    const onTouchMove = (e) => {
      const t = e.touches[0];
      const dx = Math.abs(t.clientX - startX);
      const dy = Math.abs(t.clientY - startY);
      if (dx > dy && !isInsideXScroll(e.target)) {
        e.preventDefault(); // handler non-passive -> vedi addEventListener sotto
      }
    };

    window.addEventListener("touchstart", onTouchStart, { passive: true });
    window.addEventListener("touchmove", onTouchMove, { passive: false });

    return () => {
      window.removeEventListener("touchstart", onTouchStart);
      window.removeEventListener("touchmove", onTouchMove);
    };
  }, []);

  // ✅ fai la guardia token DOPO gli hook
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="text-stone-50 flex max-w-[1920px] mx-auto">
      <ScrollToTop />
      <BackspaceNavigation />

      <div className="fixed inset-0 z-0 flex justify-center items-center pointer-events-none overflow-hidden">
        <img
          src={_BKG_LOGO}
          alt="Logo"
          className="w-[600px] md:w-[800px] opacity-50 blur-sm rotate-[-20deg]"
        />
      </div>

      <MobileNavProvider>
        {!isMD ? (
          <>
            <Header />
            <Sidebar />
          </>
        ) : (
          <HeaderMobile />
        )}
      </MobileNavProvider>

      {/* scroll solo verticale + niente overflow orizzontale */}
      <main className="w-full ml-0 md:ml-[7.5rem] min-h-screen overflow-y-auto overflow-x-hidden pl-4 md:pl-6 lg:pl-8">
        {children}
        <footer className="mt-12 border-t border-white/10 text-white/70">
          <div className="mt-8 pt-6 text-center">
            <p className="text-base text-white/50">
              © {new Date().getFullYear()} MYTV — Tutti i diritti riservati.<br />
               Versione: {packageJson.version}
            </p>

          </div>
        </footer>
      </main>

    </div>
  );
}

export default Layout;
